import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { Skeleton } from '@/components/ui/skeleton';
import { usePathname } from '@/lib/compat/navigation';
import { getSidebarForPath } from '@/config/navigation';

const PUBLIC_ROUTE_PREFIXES = [
  '/login',
  '/signup',
  '/accept-invite',
  '/reset-password',
  '/verify-email',
  '/verify-2fa',
  '/select-store',
  '/onboarding',
];

function WorkspaceSkeleton() {
  return (
    <div
      aria-busy="true"
      className="mx-auto flex w-full max-w-[1480px] flex-col gap-4 px-4 py-5 lg:px-0 lg:py-0"
    >
      <div className="flex items-end justify-between gap-4 border-b border-border/80 pb-5">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-8 w-56 max-w-full" />
          <Skeleton className="h-4 w-72 max-w-full" />
        </div>
        <Skeleton className="hidden h-10 w-32 sm:block" />
      </div>

      <div className="flex max-w-md items-center gap-2">
        <Skeleton className="h-10 flex-1 rounded-lg" />
        <Skeleton className="size-10 rounded-lg" />
      </div>

      <div className="flex gap-2 border-b border-border/80 pb-3">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} className="h-9 w-20 rounded-lg" />
        ))}
      </div>

      <Skeleton className="min-h-[430px] w-full rounded-xl" />
    </div>
  );
}

export function RoutePending() {
  const pathname = usePathname();
  const isPublicRoute = PUBLIC_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

  if (isPublicRoute) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-6">
        <div className="flex w-full max-w-md flex-col gap-4" aria-busy="true">
          <Skeleton className="mx-auto h-12 w-28" />
          <Skeleton className="h-10 w-2/3 self-end" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="mt-5 h-12 w-full" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </div>
      </div>
    );
  }

  return (
    <DashboardLayout sidebarSections={getSidebarForPath(pathname)}>
      <WorkspaceSkeleton />
    </DashboardLayout>
  );
}
